export class OrderListedFilterEntity {
  userId?: string
  branchId?: number
  categoryId?: number
  searchWord?: string
  branchCompanyId?: number
  mealTierId?: number
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
